const makeProduct = (item) => {
  const key = String(item.id).padStart(2, "0");
  const images = [
    `/assets/products/product-${key}-1.jpg`,
    `/assets/products/product-${key}-2.jpg`,
  ];
  return {
    image: images[0],
    images,
    colors: [],
    size: ["One item (as pictured)"],
    purchasable: true,
    ...item,
    price: Number(item.price).toFixed(2),
    description: [item.use, item.detail],
    Features: item.features,
  };
};

const productData = [
  makeProduct({
    id: 1,
    name: "Unbranded Silver Threaded Gas Cylinder Pair",
    category: "Pressurised Containers",
    price: 168,
    inventory: 0,
    purchasable: false,
    size: ["Pair (as pictured)"],
    colors: ["Brushed silver / brass tone / white"],
    material: "Visible only: silver-colour metal cylinders, brass-tone threaded valve assemblies and blank white label areas. The alloy, liner and valve materials are not identified.",
    specifications: "Two tall cylinders with threaded top valves are pictured. No maker, gas type, valve standard, rated pressure, compatible appliance, inspection date or fill status is visible.",
    use: "The images resemble a pair of refillable gas cylinders, but the intended gas and appliance compatibility cannot be established from appearance alone.",
    detail: "The photographs do not prove that the cylinders contain CO2, are filled, are food-service rated or are safe to connect.",
    care: "Do not fill, transport, connect or use these cylinders until the physical label, inspection record and supplier documentation have been verified.",
    cautions: "PRESSURISED-CONTAINER HOLD: missing identification can create rupture, leakage, incompatibility and transport risks.",
    features: ["Two cylinders pictured", "Threaded top valves", "Blank label areas"],
    holdReason: "Unavailable until the supplier provides the manufacturer, gas type, compatible models, valve standard, rated pressure, inspection date, fill state and required transport/safety documents.",
  }),
  makeProduct({
    id: 2,
    name: "Unbranded Charcoal Push-Up Balm Stick",
    category: "Personal Care — Documentation Pending",
    price: 98,
    inventory: 0,
    purchasable: false,
    colors: ["Charcoal casing / off-white balm"],
    material: "Visible only: a dark cylindrical push-up casing containing a pale solid balm. The casing composition and cosmetic ingredients are not shown.",
    specifications: "One unlabeled balm stick is pictured with orchid styling props. No net weight, ingredient panel, batch code, period-after-opening mark or manufacturer is visible.",
    use: "The push-up format suggests a solid personal-care balm, but the intended body area and product function cannot be confirmed from the images.",
    detail: "The orchid prop describes the photograph only; it is not evidence of fragrance, extract, formula or product name.",
    care: "Do not apply or distribute until the sealed product label and cosmetic safety documentation are available.",
    cautions: "COSMETIC HOLD: unknown ingredients and allergens prevent an informed patch test or safe-use assessment.",
    features: ["Push-up format", "Off-white solid balm", "Unlabeled charcoal casing"],
    holdReason: "Unavailable until the supplier provides a full ingredient list, allergens/fragrance disclosure, net weight, batch and expiry/PAO details, responsible manufacturer and safe-use directions.",
  }),
  makeProduct({
    id: 3,
    name: "Clear Travel Cup with Rose Sip Lid & Cork-Texture Sleeve",
    category: "Drinkware",
    price: 158,
    inventory: 10,
    foodContact: true,
    colors: ["Clear / cork brown / dusty rose"],
    material: "Visible only: a clear rigid cup, cork-textured grip sleeve and rose-colour flexible lid. Exact glass and lid grades are not shown.",
    specifications: "One tapered cup with a removable sleeve and sip opening is pictured. Capacity, heat rating and leak resistance are not visible.",
    use: "Shown holding a coffee-colour drink as a reusable takeaway-style cup.",
    detail: "The second image shows the lid removed and the sleeve fitted around the middle of the cup.",
    care: "Wash the cup, lid and sleeve before first use and follow any temperature and dishwasher directions on the physical label. Transport upright unless the label confirms a leak-resistant closure.",
    cautions: "DELIVERY CONTROL: use for drinks only when the supplied cup, lid and sleeve match the material specification and carry the required lot evidence. The lid is not represented as leakproof.",
    features: ["Removable rose lid", "Cork-textured sleeve", "Clear tapered cup"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "Borosilicate glass 3.3 cup; platinum-cured, peroxide-free food-contact silicone lid" },
      { label: "Grip and exterior parts", value: "Natural cork sleeve bonded with a food-contact-compliant adhesive; the sleeve must not contact the drink" },
      { label: "Specified use range", value: "Drinks from 0–100°C; no direct flame, stovetop, freezer-to-boiling thermal shock or sealed transport claim" },
      { label: "Lot acceptance", value: "Supplier composition declaration plus migration report covering the glass, silicone, pigments and adhesive for the stated use" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Reusable takeaway-style cup for a coffee-colour drink" },
      { label: "Pictured contact parts", value: "Clear rigid cup and the inner surface of the rose sip lid" },
      { label: "Included pieces", value: "One cup, one removable sip lid and one cork-textured grip sleeve" },
    ],
  }),
  makeProduct({
    id: 4,
    name: "Long-Handle Wood-Finish Body Brush",
    category: "Bath Accessories",
    price: 118,
    inventory: 23,
    colors: ["Natural wood tone / cream"],
    material: "Visible only: a wood-grain handle, pale dense bristles and a light hanging cord. The wood species and bristle fibre are not identified.",
    specifications: "One long curved handle with an oval bristle head and hanging hole is pictured.",
    use: "The long handle and bristle head indicate a bath or dry-body brush intended to reach the back and legs.",
    detail: "The close view shows two bristle lengths, with a denser textured centre and longer outer rows.",
    care: "Use light pressure, rinse after wet use and hang with airflow. Do not soak the handle.",
    cautions: "Avoid the face, broken skin and irritated areas. Fibre firmness and allergy information are not supplied in the images.",
    features: ["Long curved handle", "Oval bristle head", "Hanging cord"],
  }),
  makeProduct({
    id: 5,
    name: "Lavender-Tone Cosmetic Gel Jar with Spatula",
    category: "Cosmetics — Documentation Pending",
    price: 138,
    inventory: 0,
    purchasable: false,
    colors: ["Translucent lavender / sage lid / clear spatula"],
    material: "Visible only: a translucent purple gel in a clear jar with a sage-colour lid and clear spatula. Formula and packaging materials are not identified.",
    specifications: "One unlabeled cosmetic-style jar and spatula are pictured. No volume, ingredient list, batch code, expiry/PAO mark or manufacturer is visible.",
    use: "The jar and applicator suggest a topical cosmetic gel, but its purpose, application area and contact time cannot be confirmed from appearance.",
    detail: "Lavender flowers are styling props and do not prove that lavender, vitamin E or any other ingredient is present.",
    care: "Keep sealed and do not apply until the complete physical label and safe-use directions have been checked.",
    cautions: "COSMETIC HOLD: do not infer benefits, ingredients or skin suitability from colour or props.",
    features: ["Translucent gel appearance", "Sage-colour lid", "Spatula pictured"],
    holdReason: "Unavailable until ingredients, allergens, intended use, net contents, batch, expiry/PAO, manufacturer and directions are documented.",
  }),
  makeProduct({
    id: 6,
    name: "Polished Dark Brown Mottled Bowl",
    category: "Bowls",
    price: 78,
    inventory: 10,
    foodContact: true,
    colors: ["Dark brown / natural mottling"],
    material: "Visible only: a thin, polished, brown bowl with irregular pale grain-like markings. The source material and food-contact finish are not shown.",
    specifications: "One rounded bowl with a naturally irregular-looking surface is pictured. Diameter, depth and capacity are not provided.",
    use: "A lightweight-looking rounded bowl pictured as an open serving or storage vessel.",
    detail: "The polished interior continues the dark brown mottled pattern across the rounded bowl.",
    care: "Hand-wash gently, avoid soaking and follow the physical label before using with hot, oily or acidic food. Do not microwave or place in a dishwasher unless the label expressly permits it.",
    cautions: "DELIVERY CONTROL: use with food only when the supplied bowl matches the natural-shell and finish specification. Restrict use to cool, dry foods and discard a cracked, softened or mould-affected bowl.",
    features: ["Rounded profile", "Polished dark surface", "Irregular mottled pattern"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "One-piece natural coconut shell, mechanically polished; no melamine, bamboo-plastic composite, synthetic resin or painted interior" },
      { label: "Surface finish", value: "Food-contact-grade refined plant oil and beeswax finish only; no undisclosed lacquer or stain" },
      { label: "Specified use range", value: "Cool or room-temperature dry foods only, maximum 40°C; no liquids, acidic, oily or high-moisture foods" },
      { label: "Lot acceptance", value: "Species/material declaration, coating composition and migration report for the finished bowl; reject cracked, delaminated or mould-affected units" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Open bowl for serving, display or lightweight storage" },
      { label: "Pictured contact parts", value: "Polished dark interior with natural-looking pale mottling" },
      { label: "Included pieces", value: "One round bowl" },
    ],
  }),
  makeProduct({
    id: 7,
    name: "Blue & White Bead Refill Pouches",
    category: "Household Refill — Documentation Pending",
    price: 68,
    inventory: 0,
    purchasable: false,
    size: ["Two pouches (as pictured)"],
    colors: ["Kraft brown / white / blue"],
    material: "Visible only: two unlabelled kraft resealable pouches containing small white and blue beads. Chemical composition and pouch materials are not identified.",
    specifications: "Two differently sized pouches and loose beads are shown. Weight, purpose, dosage and compatible appliance or container are not visible.",
    use: "The images show a granular refill format, but they do not establish that the contents are laundry minerals, fragrance beads or another product.",
    detail: "No scent, wash count, cleaning claim or environmental claim can be supported from the photographs.",
    care: "Keep sealed and away from children, pets, food and moisture until the contents and safe handling instructions are confirmed.",
    cautions: "CHEMICAL-CONTENTS HOLD: do not ingest, mix, heat or use unidentified beads.",
    features: ["Two resealable pouches", "Blue and white beads", "Unlabelled packaging"],
    holdReason: "Unavailable until the supplier provides product identity, composition, intended use, dosage, hazard/first-aid information, net weight, batch and manufacturer.",
  }),
  makeProduct({
    id: 8,
    name: "Blue Woven Relaxation Pillow with Removable Insert",
    category: "Relaxation Accessories — Documentation Pending",
    price: 108,
    inventory: 0,
    purchasable: false,
    colors: ["Blue-grey cover / natural insert"],
    material: "Visible only: a blue-grey woven outer cover and a natural-colour fabric insert. Fibre and filling composition are not shown.",
    specifications: "One rectangular pillow, one removable insert and a plain kraft box are pictured. Exact dimensions, fill weight and closure details are not supplied.",
    use: "The narrow rectangular form suggests an eye or relaxation pillow, but weight, aroma and hot/cold suitability cannot be confirmed from appearance.",
    detail: "Lavender flowers and loose buds are styling props; they do not prove that the insert contains lavender or grain.",
    care: "Do not heat, chill or wash the filled insert without verified instructions. Keep the insert dry.",
    cautions: "FILLING-CONTENTS HOLD: unknown botanical or grain fillings may create allergy, moisture and overheating risks.",
    features: ["Rectangular woven cover", "Removable inner insert", "Plain kraft box pictured"],
    holdReason: "Unavailable until filling, allergens, dimensions, weight, manufacturer, batch and verified heating/cooling and cleaning instructions are supplied.",
  }),
  makeProduct({
    id: 9,
    name: "Mustard & Sage Porous Sponge Pair",
    category: "Cleaning Accessories",
    price: 58,
    inventory: 42,
    size: ["Pair (as pictured)"],
    colors: ["Mustard / sage"],
    material: "Visible only: two rectangular porous foam-like sponges. Fibre or polymer composition is not shown.",
    specifications: "Two similarly sized sponges with open-cell texture are pictured, dry and beside water.",
    use: "A two-colour sponge pair for routine wiping or washing on surfaces compatible with the physical product instructions.",
    detail: "The photographs do not prove cellulose content, compostability or expansion performance.",
    care: "Rinse after use, squeeze gently and air-dry. Replace if odour, tearing or embedded debris develops.",
    cautions: "Test on a hidden area before using on delicate finishes; keep away from hot cookware and flame.",
    features: ["Two-piece set", "Open porous texture", "Two identifying colours"],
  }),
  makeProduct({
    id: 10,
    name: "Unbranded Sage Push-Up Balm Stick",
    category: "Personal Care — Documentation Pending",
    price: 98,
    inventory: 0,
    purchasable: false,
    colors: ["Sage casing / off-white balm"],
    material: "Visible only: a sage-colour cylindrical push-up casing containing a pale solid balm. Ingredients and casing composition are not shown.",
    specifications: "One unlabeled balm stick is pictured with green citrus styling props. Net weight, formula, batch and manufacturer are not visible.",
    use: "The format suggests a solid personal-care balm, but deodorant use and body-area suitability cannot be confirmed from the images.",
    detail: "Citrus props do not prove lime, bergamot, fragrance or any ingredient claim.",
    care: "Do not apply or distribute until the sealed product label and cosmetic safety documentation are available.",
    cautions: "COSMETIC HOLD: unknown ingredients and allergens prevent an informed safe-use assessment.",
    features: ["Push-up format", "Off-white solid balm", "Unlabeled sage casing"],
    holdReason: "Unavailable until a complete ingredient and allergen list, net weight, batch, expiry/PAO, responsible manufacturer and directions are documented.",
  }),
  makeProduct({
    id: 11,
    name: "Natural-Tone Mesh Soap Pouch",
    category: "Bath Accessories",
    price: 48,
    inventory: 47,
    colors: ["Natural cream"],
    material: "Visible only: a coarse woven natural-tone pouch, braided drawcord, wooden bead and tassel. Fibre species is not shown.",
    specifications: "One drawstring pouch is pictured holding a rectangular soap bar; dimensions are not provided.",
    use: "A mesh pouch for holding and lathering a compatible soap bar while the cord provides a hanging point.",
    detail: "The open weave is visible from both sides; exfoliation level and fibre identity are not certified by the image.",
    care: "Rinse after use, empty trapped residue and hang fully open to dry.",
    cautions: "Use gently and avoid broken or irritated skin. Replace if the cord, bead or weave becomes damaged.",
    features: ["Open woven pouch", "Drawstring closure", "Wood-look bead and tassel"],
  }),
  makeProduct({
    id: 12,
    name: "Coral Flexible Straw & Cleaning Kit",
    category: "Drink Accessories",
    price: 62,
    inventory: 10,
    foodContact: true,
    colors: ["Coral / silver tone"],
    material: "Visible only: a coral flexible tube, a slim metal-wire brush and a silver-colour screw-top case. Material and food-contact grades are not shown.",
    specifications: "One coilable straw-like tube, one cleaning brush and one cylindrical storage case are pictured.",
    use: "A portable drinking-straw-style kit with a brush for cleaning the inside of the tube.",
    detail: "The second view shows all three pieces separated and the case open.",
    care: "Clean the full bore with the supplied brush before first use and after each drink, then dry completely before coiling it into the case. Follow the physical label for temperature and dishwasher limits.",
    cautions: "DELIVERY CONTROL: use only when the supplied straw matches the platinum-silicone specification and carries the required lot evidence. The cleaning brush and case cap are small detachable parts.",
    features: ["Flexible coral tube", "Slim cleaning brush", "Screw-top travel case"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "100% platinum-cured, peroxide-free food-contact silicone straw with no internal coating or plant-fibre filler" },
      { label: "Accessories", value: "304 stainless-steel brush wire and case; food-contact nylon brush bristles" },
      { label: "Specified use range", value: "Cold and hot drinks from 0–100°C; not for chewing, damaged tubing or children under 3 years" },
      { label: "Lot acceptance", value: "Silicone composition declaration, volatile/extractable and migration report, plus colourant compliance for repeated food contact" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Portable reusable drinking straw with a cleaning and storage kit" },
      { label: "Pictured contact parts", value: "Coral flexible tube with an open bore at both ends" },
      { label: "Included pieces", value: "One flexible straw, one wire-handled cleaning brush and one screw-top cylindrical case" },
    ],
  }),
  makeProduct({
    id: 13,
    name: "Clear Travel Cup with Sage Sip Lid & Grip Sleeve",
    category: "Drinkware",
    price: 148,
    inventory: 10,
    foodContact: true,
    colors: ["Clear / sage"],
    material: "Visible only: a clear rigid cup with a sage-colour sleeve and matching sip lid. Exact glass and flexible-material grades are not shown.",
    specifications: "One tall tapered cup with removable lid and grip sleeve is pictured. Capacity, heat rating and leak resistance are not provided.",
    use: "Shown holding a coffee-colour drink as a reusable takeaway-style cup.",
    detail: "The second image shows the wide rim and removable lid beside the cup.",
    care: "Wash the cup, lid and sleeve before first use and follow any temperature and dishwasher directions on the physical label. Transport upright unless the label confirms a leak-resistant closure.",
    cautions: "DELIVERY CONTROL: use for drinks only when the supplied cup, lid and sleeve match the material specification and carry the required lot evidence. The lid is not represented as leakproof.",
    features: ["Removable sip lid", "Full grip sleeve", "Clear tapered cup"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "Borosilicate glass 3.3 cup; platinum-cured, peroxide-free food-contact silicone lid" },
      { label: "Grip and exterior parts", value: "Platinum-cured food-contact silicone sleeve with compliant sage pigment" },
      { label: "Specified use range", value: "Drinks from 0–100°C; no direct flame, stovetop, freezer-to-boiling thermal shock or sealed transport claim" },
      { label: "Lot acceptance", value: "Supplier composition declaration plus migration report covering the glass, silicone and pigments for the stated use" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Reusable takeaway-style cup for a coffee-colour drink" },
      { label: "Pictured contact parts", value: "Clear rigid cup and the inner surface of the sage sip lid" },
      { label: "Included pieces", value: "One tall cup, one removable sip lid and one sage grip sleeve" },
    ],
  }),
  makeProduct({
    id: 14,
    name: "Charcoal & Rust Heart-Motif Ribbed Socks",
    category: "Socks",
    price: 72,
    inventory: 38,
    size: ["One pair; size not shown"],
    colors: ["Charcoal / rust"],
    material: "Visible only: a ribbed dark knit with rust-colour cuffs, heels, toes and a small heart motif. Fibre composition is not shown.",
    specifications: "One mid-calf-style pair is pictured. Size, yarn blend and reinforcement details are not visible.",
    use: "A casual two-tone pair of ribbed socks for everyday wear when the physical size label is suitable.",
    detail: "The small rust heart appears near the outer ankle of one sock; no wording or recipient theme is shown.",
    care: "Wash according to the sewn-in label with similar colours and reshape to air-dry.",
    cautions: "Confirm size and fibre sensitivities from the physical label before wear.",
    features: ["Ribbed knit", "Contrast cuff, heel and toe", "Small heart motif"],
  }),
  makeProduct({
    id: 15,
    name: "Sage Mixed-Page Hardcover Notebook",
    category: "Stationery",
    price: 168,
    inventory: 25,
    colors: ["Muted sage / cream pages"],
    material: "Visible only: a textured sage hardcover, cream paper, elastic closure and ribbon marker. Cover and paper composition are not shown.",
    specifications: "One rounded-corner notebook is pictured with at least one ruled page and one dotted page. Page count and dimensions are not visible.",
    use: "A flexible notebook for writing, planning, lists or dot-grid layouts.",
    detail: "The images do not show dated prompts, a 12-week programme or wellness content.",
    care: "Keep dry and test ink on an inconspicuous page if bleed-through is a concern.",
    cautions: "Page layouts may vary beyond the photographed spread; exact format requires confirmation from the physical item.",
    features: ["Hard cover", "Elastic closure", "Ribbon marker", "Ruled and dotted pages pictured"],
  }),
  makeProduct({
    id: 16,
    name: "Green Ceramic Plant-Watering Reservoir",
    category: "Plant Care",
    price: 128,
    inventory: 13,
    colors: ["Matte green / natural cork"],
    material: "Visible only: a matte green ceramic-looking vessel with a removable cork stopper. Ceramic porosity and cork composition are not certified by the images.",
    specifications: "One small bulb-shaped reservoir is shown alone and partly buried in potting soil beside a houseplant.",
    use: "The planted view indicates a refillable reservoir intended to release water into surrounding potting soil.",
    detail: "The stopper covers the top opening; capacity and release rate are not provided.",
    care: "Insert into loose soil without forcing, rinse between uses and protect from impact and freezing.",
    cautions: "Continue checking soil moisture; watering rate varies with pot, soil, plant and temperature.",
    features: ["Bulb-shaped vessel", "Top refill opening", "Removable cork stopper"],
  }),
  makeProduct({
    id: 17,
    name: "Amber Glass Botanical Candle with Wood Lid",
    category: "Candles — Documentation Pending",
    price: 118,
    inventory: 0,
    purchasable: false,
    colors: ["Amber / cream wax / natural wood"],
    material: "Visible only: an amber glass vessel, pale wax, a single light-colour wick and a wood-look lid. Wax, wick, fragrance and lid materials are not identified.",
    specifications: "One unlabeled single-wick candle is pictured. Net weight, burn time, fragrance name, manufacturer, batch and safety label are not visible.",
    use: "The images show a lidded container candle styled with coriander-like seeds and pink flowers.",
    detail: "The styling props do not establish coriander, geranium, vetiver or any fragrance formula, and the photographs do not prove a 210 g weight or soy wax.",
    care: "Do not burn or sell until the required candle label and verified burn instructions are available.",
    cautions: "CANDLE HOLD: wax composition, fragrance allergens, vessel heat suitability and tested burn behaviour are unknown.",
    features: ["Amber glass vessel", "Single visible wick", "Removable wood-look lid"],
    holdReason: "Unavailable until wax and wick composition, fragrance/allergen disclosure, net weight, batch, manufacturer, tested burn time and fire-safety label are supplied.",
  }),
  makeProduct({
    id: 18,
    name: "Amber Pump-Bottle Care Duo",
    category: "Personal Care — Documentation Pending",
    price: 168,
    inventory: 0,
    purchasable: false,
    size: ["Two bottles (as pictured)"],
    colors: ["Amber / black / sage label panels"],
    material: "Visible only: two amber-colour pump bottles, one containing clear gel-like liquid and one opaque cream-like liquid. Formulas and bottle materials are not shown.",
    specifications: "Two unlabeled pump bottles are pictured. Product identity, volume, ingredients, batch, expiry/PAO and manufacturer are not visible.",
    use: "The pair appears styled as complementary personal-care products, but hand wash, lotion or any other function cannot be confirmed from appearance.",
    detail: "The white cream shown in a dish does not establish the contents or performance of either bottle.",
    care: "Do not apply or distribute until each bottle has a complete, traceable label and safe-use directions.",
    cautions: "COSMETIC-CONTENTS HOLD: clear and opaque liquids cannot be identified by appearance.",
    features: ["Two pump bottles", "Amber-colour containers", "Blank sage label panels"],
    holdReason: "Unavailable until both products have identities, ingredients, allergens, net contents, batch, expiry/PAO, manufacturer and directions.",
  }),
  makeProduct({
    id: 19,
    name: "Gold-Tone Heart Tea Infuser",
    category: "Tea Accessories",
    price: 55,
    inventory: 10,
    foodContact: true,
    colors: ["Gold tone"],
    material: "Visible only: gold-tone fine mesh, a hinged frame, short chain and hook. Base metal and food-contact coating are not shown.",
    specifications: "One heart-shaped mesh infuser with a hinged opening and retrieval chain is pictured.",
    use: "The open view shows loose tea held inside the mesh heart for steeping in a cup or pot.",
    detail: "The fine mesh closes around the tea while the chain remains outside the drink for retrieval.",
    care: "Rinse before first use, empty the leaves after steeping and wash the mesh carefully so residue does not remain at the hinge. Dry open and follow any temperature directions on the physical label.",
    cautions: "DELIVERY CONTROL: use only when the supplied infuser matches the 316L/PVD specification and carries the required lot evidence. Stop use if the finish flakes, pits or corrodes.",
    features: ["Heart-shaped mesh basket", "Hinged opening", "Retrieval chain and hook"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "316L stainless-steel mesh, frame and hinge with smooth, cleanable joints" },
      { label: "Gold-tone finish", value: "Food-contact-tested titanium-nitride PVD finish; no electroplated cadmium, lead or undisclosed nickel release" },
      { label: "Specified use range", value: "Loose-tea infusion in water up to 100°C; rinse immediately after use and do not use if pitted, flaking or corroded" },
      { label: "Lot acceptance", value: "Alloy certificate plus metal-release and coating-migration report on the finished infuser under repeated hot-water use" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Heart-shaped mesh infuser for holding loose tea while steeping" },
      { label: "Pictured contact parts", value: "Two fine-mesh heart halves, hinged frame and closure edge" },
      { label: "Included pieces", value: "One hinged infuser with a short retrieval chain and hook" },
    ],
  }),
  makeProduct({
    id: 20,
    name: "Speckled Reusable Cup with Black Lid",
    category: "Drinkware",
    price: 138,
    inventory: 10,
    foodContact: true,
    colors: ["Warm grey speckle / charcoal"],
    material: "Visible only: a rigid speckled cup body and dark press-on-style sip lid. Composition and food-contact grades are not shown.",
    specifications: "One tapered cup with a removable lid is pictured. Capacity, heat rating and closure performance are not provided.",
    use: "A takeaway-style reusable cup for drinks compatible with the instructions on the physical product.",
    detail: "The removable charcoal lid has a raised drinking opening and sits over the tapered speckled cup.",
    care: "Wash the cup and lid before first use and follow any temperature and dishwasher directions on the physical label. Transport upright because the images do not demonstrate a sealed closure.",
    cautions: "DELIVERY CONTROL: use only when the supplied cup and lid match the virgin-PP specification and carry the required lot evidence. The product is not represented as insulated or leakproof.",
    features: ["Speckled tapered body", "Removable dark lid", "Sip opening"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "Virgin food-contact-grade polypropylene (PP) cup and lid with compliant mineral pigment masterbatch" },
      { label: "Excluded composition", value: "No bamboo, wheat, rice-husk or other plant-fibre filler; no melamine-formaldehyde resin; no recycled polymer in the contact layer" },
      { label: "Specified use range", value: "Drinks from 0–100°C; top-rack dishwasher only when the delivered label confirms it; not for oven or stovetop use" },
      { label: "Lot acceptance", value: "Resin and additive declaration plus overall and specific migration report for repeated contact at the stated temperature" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Reusable takeaway-style cup with a drinking opening" },
      { label: "Pictured contact parts", value: "Warm-grey speckled cup interior and inner surface of the charcoal lid" },
      { label: "Included pieces", value: "One tapered cup and one removable sip lid" },
    ],
  }),
  makeProduct({
    id: 21,
    name: "Clip-Lid Metal Lunch Box with Divider",
    category: "Food Storage",
    price: 178,
    inventory: 10,
    foodContact: true,
    colors: ["Brushed silver / sage seal"],
    material: "Visible only: a brushed metal box and lid, sage-colour rim seal, metal side clips and removable metal divider. Alloy and seal grades are not shown.",
    specifications: "One rectangular box with two side clips and a single divider is pictured. Capacity, leak resistance and food-contact certification are not visible.",
    use: "The open divided format indicates a lunch or food-storage box for separating two portions.",
    detail: "The divider appears removable and the lid is held by clips on both sides.",
    care: "Wash all removable parts before first use, dry the clips and rim thoroughly and follow the physical label for dishwasher, freezer, oven and microwave limits. Keep upright unless leak resistance is stated on the label.",
    cautions: "DELIVERY CONTROL: use only when the supplied box, divider and seal match the 316L/silicone specification and carry the required lot evidence. Never place the metal box in a microwave.",
    features: ["Two side clips", "Sage-colour rim seal", "Removable divider pictured"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "Uncoated 316L stainless-steel box, lid interior and removable divider; platinum-cured food-contact silicone rim seal" },
      { label: "Exterior hardware", value: "304 stainless-steel side clips with no cadmium- or lead-containing plating" },
      { label: "Specified use range", value: "Food storage from −20–100°C; not microwave-safe; keep upright unless the delivered batch passes the declared leak test" },
      { label: "Lot acceptance", value: "Alloy certificates, silicone declaration, finished-article migration report and documented closure/leak test" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Rectangular lunch or food-storage box with two compartments" },
      { label: "Pictured contact parts", value: "Brushed metal-look box, lid interior, removable divider and sage-colour rim seal" },
      { label: "Included pieces", value: "One box, one clip lid, one rim seal and one removable divider" },
    ],
  }),
  makeProduct({
    id: 22,
    name: "Botanical-Print Reusable Food Wrap Set",
    category: "Food Storage",
    price: 86,
    inventory: 10,
    foodContact: true,
    size: ["Three sizes (as pictured)"],
    colors: ["Cream / sage leaves / mustard flowers"],
    material: "Visible only: three flexible botanical-print fabric-like sheets with a coated appearance. Fibre and coating composition are not shown.",
    specifications: "Three graduated square wraps are pictured folded flat and shaped around bread and cut citrus.",
    use: "A reusable wrap set shown covering bread and produce for short-term storage.",
    detail: "The three botanical-print wraps are supplied in graduated square formats for different food sizes.",
    care: "Wipe or hand-wash gently in cool water, then air-dry flat unless the physical label states otherwise. Keep away from ovens, microwaves, direct flame and hot food.",
    cautions: "DELIVERY CONTROL: use only when the supplied wraps match the cotton/beeswax/jojoba specification and carry the required lot evidence. Contains beeswax; never use for raw meat, raw fish or hot food.",
    features: ["Three graduated sizes", "Botanical print", "Flexible wrap format"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "100% cotton cloth coated only with food-grade beeswax and jojoba oil; no PFAS, PVC, phthalates, synthetic resin or pine rosin" },
      { label: "Print requirements", value: "Low-migration food-contact pigments applied beneath the coating; no metallic or fluorescent inks" },
      { label: "Specified use range", value: "Cool dry foods, bread, whole fruit and cut produce from 0–40°C; not for raw meat, raw fish, hot food, microwave, oven or freezer" },
      { label: "Lot acceptance", value: "Full coating and ink composition, allergen disclosure for beeswax, and migration report for the declared food types and conditions" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Flexible reusable wraps shown around bread and cut citrus" },
      { label: "Pictured contact parts", value: "Cream botanical-print coated fabric-like surface" },
      { label: "Included pieces", value: "Three square wraps in graduated pictured sizes" },
    ],
  }),
  makeProduct({
    id: 23,
    name: "Terracotta-Coated Bottle with Screw Cap",
    category: "Water Bottles",
    price: 168,
    inventory: 10,
    foodContact: true,
    colors: ["Matte terracotta / silver rim"],
    material: "Visible only: a metal bottle mouth, terracotta-coated body and matching screw cap with a dark internal stopper. Metal grade and coating are not shown.",
    specifications: "One slim curved bottle with a removable screw cap is pictured. Capacity, insulation and leak test are not provided.",
    use: "A reusable bottle form for compatible drinks when used within the physical product's temperature guidance.",
    detail: "The open view shows the metal neck and the cap's internal sealing component.",
    care: "Wash the bottle, cap and sealing part before first use and dry with the cap removed. Follow the physical label for hot drinks, carbonation and dishwasher suitability, and check the seal before carrying.",
    cautions: "DELIVERY CONTROL: use only when the supplied bottle, cap and gasket match the 316L/PP/silicone specification and carry the required lot evidence. Do not use for carbonated drinks unless separately rated.",
    features: ["Slim curved profile", "Screw cap", "Metal mouth", "Terracotta coating"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "Uncoated 316L stainless-steel inner wall and neck; food-contact polypropylene cap insert; platinum-cured silicone gasket" },
      { label: "Exterior construction", value: "304 stainless-steel outer wall with a lead-, cadmium- and BPA-free exterior powder coating that does not contact the drink" },
      { label: "Specified use range", value: "Still drinks from 0–95°C; not for carbonated drinks, dry ice, freezer or microwave use unless separately rated" },
      { label: "Lot acceptance", value: "Alloy and polymer declarations, finished-article migration report, coating heavy-metal report and documented cap leak test" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Reusable drinks bottle with a removable screw cap" },
      { label: "Pictured contact parts", value: "316L stainless-steel inner wall and neck, PP cap insert and silicone sealing gasket" },
      { label: "Included pieces", value: "One slim bottle and one matching screw cap" },
    ],
  }),
  makeProduct({
    id: 24,
    name: "Wood-Finish Palm Dish Brush with Replaceable Head",
    category: "Cleaning Accessories",
    price: 68,
    inventory: 45,
    colors: ["Natural wood tone / cream"],
    material: "Visible only: a wood-grain handle and round head, pale bristles, internal white connector and light hanging cord. Wood and bristle species are not shown.",
    specifications: "One palm-size brush is pictured assembled and with the round bristle head detached.",
    use: "A compact scrubbing brush for dishes or sink surfaces compatible with its bristle firmness.",
    detail: "The detached view shows a replaceable-style connection between handle and bristle head.",
    care: "Rinse after use, shake out water and dry bristles-down with airflow; do not leave submerged.",
    cautions: "Test on delicate or non-stick finishes and replace the head if bristles deform or the connector loosens.",
    features: ["Palm-shape handle", "Round bristle head", "Detachable head pictured", "Hanging cord"],
  }),
  makeProduct({
    id: 25,
    name: "Natural Mesh Drawstring Produce Bag Trio",
    category: "Food-Carry Bags",
    price: 75,
    inventory: 10,
    foodContact: true,
    size: ["Three sizes (as pictured)"],
    colors: ["Natural cream"],
    material: "Visible only: three open-mesh fabric bags with matching drawstrings. Fibre composition is not shown.",
    specifications: "Three graduated bags are pictured empty and filled with produce and bread.",
    use: "A reusable drawstring bag set for grouping loose produce or other lightweight shopping items.",
    detail: "The open weave keeps contents visible while the matching drawcord closes each bag.",
    care: "Wash before first use according to the physical label, remove produce after shopping and air-dry the open bags fully. Keep drawstrings clear of small children.",
    cautions: "DELIVERY CONTROL: use only when the supplied bags match the unbleached-cotton specification and carry the required lot evidence. Drawstrings can present an entanglement hazard.",
    features: ["Three graduated sizes", "Open mesh weave", "Drawstring closures"],
    materialSpecification: [
      { label: "Direct food-contact materials", value: "100% unbleached, undyed cotton mesh and cotton drawcord; no optical brightener, antimicrobial finish, PFAS, resin or plastic coating" },
      { label: "Construction", value: "Metal-free sewn bag with securely finished seams and knots; no printed surface in the food-contact area" },
      { label: "Specified use range", value: "Whole produce, bread and dry groceries at ambient or refrigerated temperature; wash before first use and after spills" },
      { label: "Lot acceptance", value: "Fibre and finish declaration plus colourfastness, restricted-substance and migration report for direct dry-food contact" },
    ],
    foodContactDetails: [
      { label: "Pictured purpose", value: "Reusable bags shown carrying loose produce and bread" },
      { label: "Pictured contact parts", value: "Natural-colour open mesh and matching drawcords" },
      { label: "Included pieces", value: "Three drawstring mesh bags in graduated pictured sizes" },
    ],
  }),
];

export default productData;
